// /app/frontend/src/features/choral-intelligence/RecommendationExplanation.jsx
import React from "react";
import RecommendationReason from "./RecommendationReason";
import RecommendationCaution from "./RecommendationCaution";

export default function RecommendationExplanation({ explanation }) {
  if (!explanation) {
    return null;
  }

  return (
    <section
      className="ci-explanation"
      aria-labelledby={`why-${explanation.work_id}`}
      data-testid={`ci-explanation-${explanation.work_id}`}
    >
      <h3
        id={`why-${explanation.work_id}`}
        className="ci-explanation__heading"
      >
        Why this recommendation
      </h3>
      <p
        className="ci-explanation__summary"
        data-testid={`ci-summary-${explanation.work_id}`}
      >
        {explanation.summary}
      </p>

      {explanation.reasons?.length > 0 && (
        <div className="ci-explanation__reasons">
          {explanation.reasons.map((reason, index) => (
            <RecommendationReason
              key={`${reason.type}-${index}`}
              reason={reason}
            />
          ))}
        </div>
      )}

      {explanation.cautions?.length > 0 && (
        <div
          className="ci-explanation__cautions"
          aria-label="Editorial cautions"
        >
          {explanation.cautions.map((caution, index) => (
            <RecommendationCaution
              key={`${caution.type}-${index}`}
              caution={caution}
            />
          ))}
        </div>
      )}
    </section>
  );
}
